import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Stack,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { Avatar } from "primereact/avatar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useNavigate } from "react-router-dom"; // if you use react-router for navigation
import "./Header.css";
// import logo from "../assests/aadilogo.png";
import logo from "../assests/LogoAays1.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";

import Tooltip from '@mui/material/Tooltip';
import axios from "axios";

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null); // anchor element for menu
  const [userRole, setUserRole] = useState("");
  const open = Boolean(anchorEl);
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const name = account?.name || "User";
  const email = account?.username || "user@aaysinsight.com";
  const [photo, setPhoto] = useState(null);


  console.log("Account Details:", account);

  // Fetch user role from API
  const getRole = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const url = `${process.env.REACT_APP_API_URL}/user/id/${userId}`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setUserRole(response.data.role_name);
    } catch (error) {
      console.error("Error fetching role:", error);
    }
  };

  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setPhoto(imageUrl);
      if(imageUrl){
        localStorage.setItem("profilePhoto", imageUrl);
      }
     
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };


  useEffect(() => {
    getRole();
    getProfilePhoto();
  }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Your logout logic here
    console.log("Logout clicked");
    handleClose();
  };

  return (
    <AppBar
      position="static"
      className="main-header"
      sx={{
        backgroundColor: "white",
        color:"black",
        height: "80px",
        justifyContent: "center",
        // background: "linear-gradient(90deg, #0101a7 0%, #3EC9F7 100%)",

      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between",alignItems: "center", height: "100%" }}>
        {/* Logo */}
        <Box sx={{ px: 2, py: 1 }}>
          {/* <img src={logo} alt="logo" className="h-[35px]" /> */}
          <img
    src={logo}
    alt="logo"
    style={{
      maxHeight: "40px",  
      maxWidth: "150px",  
      objectFit: "contain", 
    }}
  />
        </Box>

        <Box sx={{display: "flex", gap:"20px",color:'black', alignItems: "center"}}>
          <div className="flex items-center gap-4 pr-4 whitespace-nowrap">
            {["Rule Elevation", "Insights", "Request", "FAQ’s"].map(
            (text, index) => (
              <Tooltip title={"Coming Soon"} placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#bb1ccc',
                    color: 'white',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    fontWeight: 'bold',
                    // width : '100px'
                  }
                }
              }}>
              <Typography
                key={index}
                component="a"
                href="#"
                sx={{
                  color: "black",
                  fontSize: "16px",
                  fontWeight: "400",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline",color:'#bb1ccc' },
                  fontFamily: "Poppins",
                }}
              >
                {text}
              </Typography>
              </Tooltip>
            )
          )}
          </div>

          <div style={{ height: "20px", borderLeft: "1px solid white", borderRight: "1px solid white", paddingLeft: "20px", paddingRight: "20px", display: "flex", alignItems: "center" }} >


          <IconButton>
              <NotificationsIcon sx={{ color: "white", fontSize: "30px" }} />
            </IconButton>
          </div>

          {/* <div className="flex items-center gap-2">


            <Avatar
            image={photo ? photo : null}
            data-pr-tooltip={name || "User"}
            style={{
              verticalAlign: "top",
              position: "relative",
              backgroundColor: "white",
              color: "black",
              fontWeight: "bold",
              height: "35px",
              width: "35px",
              cursor: "pointer",
            }}
            onClick={handleAvatarClick}
            shape="circle"
          >
            {photo ? "" : name?.charAt(0).toUpperCase() || 'U'}
          </Avatar>
          <p className="text-black font-poppins font-normal" >{name ? name : ""}</p>

            </div> */}
            <div className="flex items-center justify-between gap-1 w-full px-3 py-2 rounded-md hover:bg-gray-50 transition">
  {/* Left side: name and email */}
  <div className="flex flex-col gap-[2px] text-right">
    <p className="text-[#bb1ccc] font-poppins font-medium text-[15px] leading-tight">
      {name || "Aays"}
    </p>
    <p className="text-[#bb1ccc] font-poppins text-[12px] leading-tight opacity-80">
      {email || "aays@example.com"}
    </p>
  </div>

  {/* Right side: avatar */}
 <div
    className="flex items-center justify-center rounded-full bg-[#bb1ccc] text-white font-semibold text-sm w-[35px] h-[35px]"
    onClick={handleAvatarClick}
  >
    {name
      ? name
          .split(" ")
          .map((word) => word[0])
          .join("")
          .toUpperCase()
      : "AA"}
  </div>
</div>

          </Box>

        {/* Navigation */}
        {/* <Stack direction="row" className="nav-link" spacing={7}>
          {["Rule Elevation", "Insights", "Request", "FAQ’s"].map(
            (text, index) => (
              <Tooltip title={"Coming Soon"} placement="top"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'black',
                    color: 'white',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    fontWeight: 'bold',
                    // width : '100px'
                  }
                }
              }}>
              <Typography
                key={index}
                component="a"
                href="#"
                sx={{
                  color: "white",
                  fontSize: "16px",
                  fontWeight: "600",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {text}
              </Typography>
              </Tooltip>
            )
          )}
        </Stack> */}

        {/* Notification and Profile */}
    
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem>
              {name}
            </MenuItem>
            {userRole === "Admin" && (
              <MenuItem
                onClick={() => {
                  navigate("/accessManagement");
                  handleClose();
                }}
              >
                Access Management
              </MenuItem>
            )}
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
            <MenuItem>
              <span style={{ overflowWrap: "anywhere" }}>
                {email}
              </span>
            </MenuItem>
          </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
